// @ts-nocheck
import React from "react";
import Select, { SelectChevron } from "./ReusableComponents/Select";

// The forecast picker, shared by the asset graph, the datasets page, the date picker and the asset dashboard cards. It stays a dropdown — the schema can carry a dozen forecasts, which a segmented control could not hold — with the toolbar pill as its trigger on the shared Select, so a phone gets the same centered card as every other picker.
const ForecastSelect = ({ activeForecast, foreCastSchema, onForecastSelect }) => {
  const active = foreCastSchema?.[activeForecast];
  const ActiveIcon = active?.Icon;
  const options = Object.entries(foreCastSchema || {})
    .filter(([, forecast]) => forecast)
    .map(([key, { Icon, name }]) => ({
      value: key,
      label: name,
      icon: Icon ? <Icon className="h-4 w-4 [&_path]:stroke-current" /> : undefined,
    }));

  return (
    <Select
      aria-label="Select forecast"
      title={active?.name || "Select forecast"}
      className="eai-btn-toolbar max-w-[11rem]"
      trigger={
        <>
          {ActiveIcon && <ActiveIcon className="h-4 w-4 shrink-0 [&_path]:stroke-current" />}
          <span className="truncate">{active?.name || "Select forecast"}</span>
          <SelectChevron className="h-3 w-3" />
        </>
      }
      value={activeForecast ?? ""}
      onChange={(e) => e.target.value !== activeForecast && onForecastSelect(e.target.value)}
      options={options}
    />
  );
};

export default ForecastSelect;
